import { render } from "./CadastrarConstrucoes.vue?vue&type=template&id=fbfeaae8"
import script from "./CadastrarConstrucoes.vue?vue&type=script&lang=js"
export * from "./CadastrarConstrucoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__